// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b4665d5","453":"dd922ece","455":"2c88fd27","977":"28928b79"}[chunkId] + ".chunk.js";
};